import { render, staticRenderFns } from "./independentNumber.vue?vue&type=template&id=3f8d68be&scoped=true"
import script from "./independentNumber.vue?vue&type=script&lang=js"
export * from "./independentNumber.vue?vue&type=script&lang=js"
import style0 from "./independentNumber.vue?vue&type=style&index=0&id=3f8d68be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8d68be",
  null
  
)

export default component.exports